function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import qs from 'qs';
import urljoin from 'url-join';
import queryStringUtils from 'query-string';
import { getAppConfig } from '@shared/services/init/appConfig';
import { getHttpPrefix } from '@src/server/utils/func';
export class Url {
    getUrl(stringifyWithQs = false) {
        if (!this.host) {
            return '';
        }
        let url = this.host.startsWith('http') ? this.host : urljoin(getHttpPrefix(), this.host);
        url += this.endpoint;
        if (this.query) {
            url += '?' + (stringifyWithQs ? qs.stringify(this.query) : queryStringUtils.stringify(this.query));
        }
        return url;
    }
    constructor(endpoint, query, host){
        _define_property(this, "host", void 0);
        _define_property(this, "query", void 0);
        _define_property(this, "endpoint", void 0);
        this.host = host || getAppConfig('hostname');
        this.endpoint = endpoint;
        this.query = query || {};
    }
}
